import {createSvgIcon} from '../create-svg-icon';

export const NorthEastIcon = createSvgIcon(
  <path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z" />
, 'NorthEastOutlined');
